import { ApolloClient, ApolloProvider, InMemoryCache } from '@apollo/client'
import { createHttpLink } from '@apollo/client/link/http'
import { setContext } from '@apollo/client/link/context'
import './App.css'
import Routing from './Routes'
import { BASE_URL } from './Services/constant'
import 'react-toastify/dist/ReactToastify.css'
import { ToastContainer } from 'react-toastify'
import AdminContext from './utils/context/TempAuth'

// const client = new ApolloClient({
//   uri: `${BASE_URL}/graphql`,
//   cache: new InMemoryCache(),
// })

const httpLink = createHttpLink({
  uri: `${BASE_URL}/graphql`,
})

const authLink = setContext((_, { headers }) => {
  const token = sessionStorage.getItem('token')
  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : '',
    },
  }
})

const client = new ApolloClient({
  link: authLink.concat(httpLink),
  cache: new InMemoryCache(),
})

function App() {
  return (
    <div className="App">
      <AdminContext>
        <ApolloProvider client={client}>
          <Routing />
          <ToastContainer
            position="top-right"
            autoClose={1000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="light"
          />
        </ApolloProvider>
      </AdminContext>
    </div>
  )
}

export default App
